import { render, staticRenderFns } from "./h-comment.vue?vue&type=template&id=70052238&scoped=true"
import script from "./h-comment.vue?vue&type=script&lang=js"
export * from "./h-comment.vue?vue&type=script&lang=js"
import style0 from "./h-comment.vue?vue&type=style&index=0&id=70052238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70052238",
  null
  
)

export default component.exports